export default angular.module("mars.vet.dnareports.controllers.learnmore",[]).controller('LearnMoreController', function($rootScope, $scope, $routeParams, $window, EntryService, EntryIDService, NavigationService, UtilityService) {
    'ngInject';
    EntryService.getEntry($routeParams.entryID).then(function(response) {
        var fields = response.fields;
        $rootScope.pageTitle = fields.title;
        $scope.description = fields.description;
        $scope.theScienceTitle = fields.theScience.title;
        $scope.theScienceDescription = fields.theScience.description;
        $scope.theScienceLink = fields.theScience.link;
        $scope.theScienceEntryID = EntryIDService.getEntryID('The Science');
        $scope.ourTechnologyTitle = fields.ourTechnology.title;
        $scope.ourTechnologyDescription = fields.ourTechnology.description;
        $scope.ourTechnologyLink = fields.ourTechnology.link;
        $scope.ourTechnologyEntryID = EntryIDService.getEntryID('Our Technology');
        $scope.inheritanceTitle = fields.inheritance.title;
        $scope.inheritanceDescription = fields.inheritance.description;
        $scope.inheritanceLink = fields.inheritance.link;
        $scope.inheritanceEntryID = EntryIDService.getEntryID('Inheritance');
        $scope.traitsTitle = fields.traits.title;
        $scope.traitsDescription = fields.traits.description;
        $scope.traitsLink = fields.traits.link;
        $scope.traitsEntryID = EntryIDService.getEntryID('LearnMoreTraits');
        $scope.identifyingBreedsTitle = fields.identifyingBreeds.title;
        $scope.identifyingBreedsDescription = fields.identifyingBreeds.description;
        $scope.identifyingBreedsLink = fields.identifyingBreeds.link
        $scope.faqsTitle = fields.commonQuestions.title;
        $scope.faqsDescription = fields.commonQuestions.description;
        $scope.faqsLink = fields.commonQuestions.link;
        $scope.faqsEntryID = EntryIDService.getEntryID('FAQs');
        $scope.glossaryTitle = fields.glossary.title;
        $scope.glossaryDescription = fields.glossary.description;
        $scope.glossaryEntryID = EntryIDService.getEntryID('Glossary');

        $scope.getVersionFeature = UtilityService.getVersionFeature;

        $scope.glossaryLink = fields.glossary.link;

        NavigationService.setNavigationUrls();
        $window.ga('send', 'pageview', {
            'page': $rootScope.pageTitle
        });
  }, function(error) {
      // promise rejected, could log the error with:
      // console.log('error', error);
  });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/learnmore.controller.js